module.exports = __webpack_public_path__ + "static/media/spa-hero-desktop.fcc35ffe.jpg";